<div class="bg-white" *ngIf="info">
  <h2 class="border-bottom p-4">
    {{ 'Sellers.Products.Details' | translate }}
  </h2>
  <div class="p-4">
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.Product' | translate }}</h6>
        <p>{{ info.productName }}</p>
      </div>
      <div *ngIf="info.subProductName" class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.SubProduct' | translate }}</h6>
        <p>{{ info.subProductName }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.PaymentMethod' | translate }}</h6>
        <p>{{ info.paymentMethod }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.ProductPrice' | translate }}</h6>
        <p>{{ info.productPrice }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.Status' | translate }}</h6>
        <p>{{ info.status }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.Quantity' | translate }}</h6>
        <p>{{ info.Quantity }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.Amount' | translate }}</h6>
        <p>{{ info.amount }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.MerchantRefNumber' | translate }}</h6>
        <p>{{ info.merchantRefNumber }}</p>
      </div>
      <div class="col-md-4 col-sm-12" *ngIf="info.promocodeTitle">
        <h6>{{ 'Sellers.Products.PromocodeTitle' | translate }}</h6>
        <p>{{ info.promocodeTitle }}</p>
      </div>
      <div class="col-md-4 col-sm-12" *ngIf="info.ticketType">
        <h6>{{ 'Sellers.Products.TicketType' | translate }}</h6>
        <p>{{ info.ticketType }}</p>
      </div>
      <div class="col-md-4 col-sm-12">
        <h6>{{ 'Sellers.Products.Date' | translate }}</h6>
        <p>{{ info.date | date }}</p>
      </div>
      <div class="col-md-12 col-sm-12">
        <button [routerLink]="['/seller/reports/buyerInfoReport']"
                routerLinkActive="active"
                type="button"
                class="btn btn-primary">
          {{ 'Sellers.Products.Back' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
